// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22nd3","left":"styles_left__2YaQk"};